<template>
	<div class="contain remove-padding-margin">
		<div class="contain remove-padding-margin" id="setproduksi">
			<div class="fixed-top bg-white">
				<div class="nav-center pageDefault">
					<div class="row set-row d-flex">
						<div class="remove-padding navbar-icon-left" @click="back">
							<img class="remove-padding-margin" @click="" src="../../../assets/gambar/back-blue.svg">
						</div>
						<div class="text-center remove-padding flex-1 font-weight-600">
							Atur Status Workshop
						</div>
						<div class="navbar-icon-right remove-padding">
						
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<main class="">
			<div class="flex-100">
				<div class="flex-1 pad-top-50">
					<div class="text-head mar-top-20 mar-bottom-16 add-padding-default">
						<div class="font-16 color-33333 line-height-25 letter-space-002">
							Apakah workshop <b>{{ workshop.nama }}</b> tetap aktif dan beroperasi di tempat lain?
						</div>
					</div>
					<div class="accordion" id="accordionExample">
						<div class="baris border-bottom">
							<div class="input-group" style="padding: 20px">
								<div class="custom-control custom-radio remove-padding-lr">
									<input type="radio" id="customRadio1" name="customRadio" class="custom-control-input"
									       data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
									       aria-controls="collapseOne" value="ya" @click="optionClicked('customRadio1')">
									<label class="custom-control-label" for="customRadio1">
										<b>Ya,</b> tetap aktifkan workshop
									</label>
									<p class="f-14 f-c-midgrey m-d-0 mar-left-25 customRadio" id="customRadio1-desc" style="display: none">
										Data workshop akan terpisah dari outlet & workshop tetap aktif
									</p>
								</div>
							</div>
						</div>
						<div class="baris border-bottom">
							<div class="input-group" style="padding: 20px">
								<div class="custom-control custom-radio remove-padding-lr w-100">
									<input type="radio" id="customRadio2" name="customRadio" class="custom-control-input"
									       data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true"
									       aria-controls="collapseTwo" value="tidak" @click="optionClicked('customRadio2')">
									<label class="custom-control-label" for="customRadio2">
										<b>Tidak,</b> sembunyikan workshop
									</label>
									<p class="f-14 f-c-midgrey m-d-0 m-t-4 mar-left-25 customRadio" id="customRadio2-desc" style="display: none">
										Data workshop akan terpisah dari outlet & di sembunyikan
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="button-lanjut add-padding-default">
					<button class="btn btn-login btn-long remove-margin" disabled id="btnNext"
					        @click="saveStatusWorkshop">
						<span class="spinner-border spinner-border-sm"
						      role="status"
						      aria-hidden="true"
						      id="loading-status-workshop"
						      style="display: none"
						></span>
						<span id="textBtn2">Simpan</span>
					</button>
				</div>
			</div>
		</main>
		
		<div class="modal fade" id="modal-ubah-status-workshop" role="dialog">
			<div class="modal-dialog modal-lg  bani-modal">
				<div class="modal-content">
					<div class="modal-header">
						<div class="nav-btn kiri"></div>
						<h5 class="navbar-title text-center">Sembunyikan Workshop</h5>
						<div class="nav-btn kanan tutup">
							<img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
						</div>
					</div>
					<div class="modal-body">
						<div class="m-d-20">Semua data keuangan akan tetap tersimpan & ditampilkan. Yakin ingin <b>sembunyikan</b> workshop <b>{{ workshop.nama }}</b>?</div>
						<div>Anda tetap bisa mengaktifkannya pada halaman daftar workshop.</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
							@click="sembunyikanWorkshop">
							Ya, sembunyikan
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "StatusWorkshop",
		props: ['dataoutlet'],
		data() {
			return {
				workshop: {},
				requestHeaders: {
					headers: {
						'Authorization': 'Bearer ' + localStorage.getItem('token'),
					}
				},
			}
		},
		methods: {
			optionClicked(id) {
				$(".customRadio").slideUp(300)
				$("#" + id +"-desc").slideDown(300);
				if ($("input[name='customRadio']:checked").val() === 'tidak') {
					$("#modal-ubah-status-workshop").modal("show");
				}
				this.checkValidate()
			},
			back() {
				this.$emit("showdetailoutlet")
			},
			checkValidate() {
				var checked = $("input[name='customRadio']:checked").val()
				if (checked !== undefined) {
					$("#btnNext").prop("disabled", false)
				} else {
					$("#btnNext").prop("disabled", true)
				}
			},
			async getDetailWorkshop() {
				try {
					const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_workshop_meta?idworkshop=' + this.dataoutlet.workshop_idworkshop + '&idowner=' + this.dataoutlet.owner_idowner, this.requestHeaders)
					this.workshop = response.data.data.workshop;
				} catch (e) {
					this.$catch_error_response(e)
					$('#loadingPage').removeClass('overlayLoading');
					$('#loadingPage').hide()
				}
			},
			saveStatusWorkshop() {
				if ($("input[name='customRadio']:checked").val() === 'tidak') {
					$("#modal-ubah-status-workshop").modal("show");
					return;
				}
				this.$emit("pisahkanWorkshop")
			},
			sembunyikanWorkshop() {
				this.$emit("sembunyikanWorkshop", this.workshop)
			}
		},
	}
</script>